import React, {Component} from 'react';
import {Dimmer, Loader} from 'semantic-ui-react';

class Loading extends Component {
  render() {
    return (
      <Dimmer.Dimmable style={{marginTop:'1em'}}>
        <Dimmer active inverted style={{background:'transparent'}}>
          <Loader inline='centered' active>{this.props.message}</Loader>
        </Dimmer>
      </Dimmer.Dimmable>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/extras/Loading.js